const VERSION = '3.1.4';
export function getVersionString() {
    return VERSION;
}
